import { push } from 'utils/navigation/navigate';
import React, { useContext } from 'react';
import { Page } from 'components/layout/panel/Page/Page';
import { LocaleContext } from 'context/locale';
import { EditorAddContainer } from 'components/childRegister/Editor/EditorAddContainer';
import { useStyles } from 'views/Panel/ChildRegister/ChildRegisterAdd/ChildRegisterAdd.styles';
import { Breadcrumb } from 'components/shared/navigation/Breadcrumbs/Breadcrumb';
import { ROUTE_CHILD_REGISTER, ROUTE_INSTITUTION_UNIT_ADD } from 'config/routes';
import classNames from 'classnames';

export const ChildRegisterAdd: React.FC = () => {
  const { trans } = useContext(LocaleContext);
  const classes = useStyles();
  const goBack = () => push(ROUTE_CHILD_REGISTER);

  return (
    <Page title={trans('CHILD_REGISTER.BROWSER.TITLE')}>
      <Breadcrumb label={trans('BREADCRUMB.CHILD-REGISTER.ADD')} to={ROUTE_INSTITUTION_UNIT_ADD} />
      <div className={classNames('container-fluid', classes.container)}>
        <EditorAddContainer goBack={goBack} />
      </div>
    </Page>
  );
};
